import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { Weight } from "@faire/web--source/slate/Font/utils";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { Typography } from "@faire/web--source/slate/Typography";
import { Link } from "@faire/web--source/ui/LinkAnchor";
import { trackCategoriesSideNavigationClick } from "@faire/web-api--source/events/categories/click/sideNavigation";
import React from "react";
import styled, { css } from "styled-components";
/**
 * Determines whether a descendent (including itself) of given {@param leftNavLink}
 * has the same identifier as {@code props.selectedIdentifier}
 */ var containsLeftNavLinkWithMatchingIdentifier = function(leftNavLink, selectedIdentifier) {
    return leftNavLink.identifier === selectedIdentifier || leftNavLink.childNavLinks.some(function(childLink) {
        return containsLeftNavLinkWithMatchingIdentifier(childLink, selectedIdentifier);
    });
};
export var SidebarLink = function(param) {
    var dataTestId = param.dataTestId, option = param.option, selectedIdentifier = param.selectedIdentifier;
    var childNavLinks = option.childNavLinks;
    var isSelected = selectedIdentifier === option.identifier;
    var _option_name;
    return /*#__PURE__*/ _jsxs(Column, {
        align: "flex-start",
        justify: "flex-start",
        "data-test-id": dataTestId,
        children: [
            /*#__PURE__*/ _jsx(StyledLink, {
                "data-test-id": "left-nav-link",
                to: option.to,
                "aria-current": isSelected ? "page" : undefined,
                onClick: function() {
                    var _option_identifier;
                    return trackCategoriesSideNavigationClick((_option_identifier = option.identifier) !== null && _option_identifier !== void 0 ? _option_identifier : "");
                },
                children: /*#__PURE__*/ _jsx(Text, {
                    variant: isSelected ? "paragraphSansMedium" : "paragraphSansRegular",
                    $isSelected: isSelected,
                    children: (_option_name = option.name) !== null && _option_name !== void 0 ? _option_name : ""
                })
            }),
            (childNavLinks === null || childNavLinks === void 0 ? void 0 : childNavLinks.length) ? /*#__PURE__*/ _jsx(SubCategoriesWrapper, {
                children: childNavLinks.map(function(link) {
                    return /*#__PURE__*/ _jsx(SubCategoryListItemWrapper, {
                        children: /*#__PURE__*/ _jsx(SubCategoryListItem, {
                            children: /*#__PURE__*/ _jsx(SidebarLink, {
                                option: link,
                                selectedIdentifier: selectedIdentifier
                            })
                        }, link.to)
                    }, link.to);
                })
            }) : null
        ]
    });
};
var SubCategoriesWrapper = styled.ul.withConfig({
    componentId: "sc-2cc7a09d-0"
})([
    "display:flex;flex-direction:column;align-items:flex-start;justify-content:flex-start;width:100%;padding-left:15px;"
]);
var SubCategoryListItemWrapper = styled(Row).attrs({
    align: "center"
}).withConfig({
    componentId: "sc-2cc7a09d-1"
})([
    ""
]);
var SubCategoryListItem = styled.li.withConfig({
    componentId: "sc-2cc7a09d-2"
})([
    "width:100%;"
]);
var StyledLink = styled(Link).withConfig({
    componentId: "sc-2cc7a09d-3"
})([
    "width:100%;height:fit-content;min-height:32px;-webkit-touch-callout:none;-webkit-user-select:none;user-select:none;display:flex;flex-direction:row;align-items:center;justify-items:flex-start;"
]);
var Text = styled(Typography).withConfig({
    componentId: "sc-2cc7a09d-4"
})([
    "&&&{padding-bottom:2px;color:",
    ";",
    ";&:hover,&:focus{border-bottom:1px solid ",
    ";font-weight:",
    ";color:",
    ";}}"
], Core.text.default, function(param) {
    var $isSelected = param.$isSelected;
    return $isSelected ? css([
        "border-bottom:1px solid ",
        ";color:",
        ";"
    ], Core.border.default, Core.text.default) : css([
        "border-bottom:1px solid transparent;"
    ]);
}, Core.border.hover, Weight.medium, Core.text.enabled);
